import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../hooks/hooks'; import PageLoader from '../../../../../components/PageLoader';
import { GlobalPinCodeComponent } from '../components/global-pin-codes.component';
import { selectGlobalPinCodesQueryItems } from '../../../../../redux/global-iship-cloud/global-pin-codes/selector';
import { globalPinCodes } from '../../../../../redux/global-iship-cloud/global-pin-codes/action';

const GlobalPinCode = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const queryItems = useSelector(selectGlobalPinCodesQueryItems)
  const [isQuery, setIsQuery] = useState<boolean>(false)
  const [
    pinCode,
    setPinCode
  ] = useState<any>({})

  const fetchRecordById = () => {
    dispatch(globalPinCodes.query({
      url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/logistics/global-iship-cloud/global-pin-codes/fetch-detail`, entity: 'globalBranches', jsonData:
      {
        Context: {},
        Records: [
          {
            "GlobalPincodeId": parmas?.id
          }
        ]
      }
    })).then(() => {
      setIsQuery(true)
    })
  }

  useEffect(
    () => {
      if (parmas?.id > 0) {
        fetchRecordById()
      }
    }, [])

  useEffect(
    () => {
      if (isQuery) {
        setPinCode(queryItems?.result?.items)
      }
    }, [isQuery])

  const handleInnerBasicFormChange: any = (event: any, field: string) => {
    setPinCode({ ...pinCode, [field]: event });
  }

  const handleFormSubmit = async (event: any) => {
    event.preventDefault();

    if (parmas?.id > 0) {
      dispatch(globalPinCodes.update({
        url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/logistics/global-iship-cloud/global-pin-codes`, entity: 'globalBranches', jsonData:
        {
          "Context": {},
          Records: [
            pinCode
          ]
        }
      })).then(() => {
        back()
      })
    } else {
      dispatch(globalPinCodes.create({
        url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/logistics/global-iship-cloud/global-pin-codes`, entity: 'globalBranches', jsonData:
        {
          "Context": {
          },
          Records: [
            pinCode
          ]
        }
      })).then(() => {
        back()
      })
    }
  }

  const back = async () => {
    navigate(-1)
  }

  return (
    <>
      {queryItems?.isLoading ? <PageLoader /> :
        <GlobalPinCodeComponent
          pinCode={pinCode}
          handleFormSubmit={handleFormSubmit}
          back={back}
          handleInnerBasicFormChange={handleInnerBasicFormChange}
        />}
    </>
  )

}

export default GlobalPinCode;